import PropTypes from 'prop-types';
import Icon from "../../../Icon/Icon";
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProgramUsersInfo = props => {
  const {
    program: {
      receiving_referrals
    },
    showProgramUsersInfo
  } = props;
  if (!receiving_referrals || !showProgramUsersInfo) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-row items-center m-5 bg-medium-fill-blue border border-solid rounded p-3",
    children: [/*#__PURE__*/_jsx(Icon, {
      className: "mr-2 flex-5",
      icon: "Warning",
      color: "brand-blue"
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "gWEbfN",
        description: "user-info-text",
        defaultMessage: "Please make sure at least one user from your organization is assigned to this program. Go to the Users tab to add users to your organization and assign them to programs."
      })
    })]
  });
};
ProgramUsersInfo.propTypes = {
  program: PropTypes.shape({
    receiving_referrals: PropTypes.bool.isRequired
  }).isRequired,
  showProgramUsersInfo: PropTypes.bool.isRequired
};
export default ProgramUsersInfo;
//# sourceMappingURL=ProgramUsersInfo.js.map